// auto-generated by bin/genVersion.ts
export const VERSION = '2.0.0-beta-2';
//# sourceMappingURL=version.js.map